module.exports =(function() {
  return function(context) {
    return (function() {
      var $o;
      $o = [];
      $o.push("<div class='actions-wrapper toggles'>\n  <div class='button medium' id='tile-view'>\n    <span class='icon icon-tiles'></span>\n  </div>\n  <div class='button medium' id='list-view'>\n    <span class='icon icon-list'></span>\n  </div>\n</div>");
      return $o.join("\n").replace(/\s(?:id|class)=(['"])(\1)/mg, "");
    }).call(context);
  };

}).call(this);



//////////////////
// WEBPACK FOOTER
// ./app/javascript/backbone/platform/templates/assets/assets_view_options.js.hamlc
// module id = 1548
// module chunks = 18